module.exports = __webpack_public_path__ + "img/ac-logo-white.edd176e1.png";